import React from 'react';

import styled from 'styled-components';

import Box from 'atoms/Box';
import { Heading, HeadingLevel } from 'atoms/Typography';

import Text from 'atoms/Text';

import { LocalizedString } from 'utils/localize';

import { theme } from 'theme';

export interface SettingContentProps {
  className?: string;
  level?: HeadingLevel;
  heading: LocalizedString;
  headingMt?: number;
  text: LocalizedString;
  textSize?: number;
  pr?: number;
}

function SettingContent({
  className,
  level = 'h2',
  heading,
  text,
  headingMt,
  textSize,
  pr,
}: SettingContentProps) {
  return (
    <Wrapper className={className} pr={pr}>
      <Heading level={level} marginTop={headingMt}>
        {heading}
      </Heading>
      <Text size={textSize}>{text}</Text>
    </Wrapper>
  );
}

export default SettingContent;

const Wrapper = styled(Box)`
  box-sizing: border-box;
  padding-bottom: 0.75em;

  ${theme.devices.tablet`
    padding-bottom: 0;
    font-size: 18px;
  `}

  ${theme.devices.desktop`
    font-size: 20px;
  `}
`;
